import React, { useState, useEffect, useRef } from "react";

export default function Level1FindMe({ questions, sound, onComplete }) {
  const [qIndex, setQIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [feedback, setFeedback] = useState(null); // { optIdx, correct }
  const startTimeRef = useRef(Date.now());

  const q = questions[qIndex];
  const total = questions.length;

  useEffect(() => {
    startTimeRef.current = Date.now();
  }, []);

  const handleTap = (option) => {
    if (feedback) return;
    const isCorrect = option === q.answer;
    sound[isCorrect ? "correct" : "wrong"]();
    setFeedback({ option, correct: isCorrect });
    if (isCorrect) setCorrectCount((c) => c + 1);

    setTimeout(() => {
      setFeedback(null);
      if (qIndex + 1 < total) {
        setQIndex((i) => i + 1);
      } else {
        const timeTakenSec = Math.round((Date.now() - startTimeRef.current) / 1000);
        onComplete({
          correctCount: correctCount + (isCorrect ? 1 : 0),
          totalQuestions: total,
          timeTakenSec,
          hintsUsed: 0,
        });
      }
    }, 700);
  };

  if (!q) return null;

  return (
    <div className="flex flex-col items-center gap-6 py-6">
      <p className="text-lg sm:text-xl font-bold text-cyan-100 text-center px-4">{q.prompt}</p>
      <div className="grid grid-cols-2 gap-4 sm:gap-5 w-full max-w-xs sm:max-w-sm px-4">
        {q.options.map((opt, idx) => {
          const isTapped = feedback?.option === opt;
          const showState = isTapped ? (feedback.correct ? "correct" : "wrong") : null;
          return (
            <button
              key={idx}
              onClick={() => handleTap(opt)}
              disabled={!!feedback}
              className={[
                "aspect-square rounded-3xl flex items-center justify-center text-5xl sm:text-6xl shadow-sm transition-all duration-200",
                showState === "correct" ? "bg-[#DCFCE7] scale-105 ring-4 ring-[#4ADE80]" :
                showState === "wrong" ? "bg-[#FEE2E2] ring-4 ring-red-300" :
                "bg-gray-800 text-gray-100 active:scale-95",
              ].join(" ")}
              aria-label={`Option ${idx + 1}`}
            >
              {opt}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-gray-100">Question {qIndex + 1} of {total}</p>
    </div>
  );
}
